import React from "react";

function HealthCheck() {
  const data = {
    status: 200,
    message: "Whitelion website Service working fine...",
  };

  return (
    <div className="min-h-screen">
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}

export default HealthCheck;
